<template>
  <div class="transaction-error text-center p-3">
    <div class="alert alert-danger shadow-sm">
      <h5 class="alert-heading mb-3">
        {{ $t('home.return.error_title') || 'Error' }}
      </h5>
      <p class="mb-3">
        {{ errorMessage }}
      </p>
      <div
        v-if="lastTransaction?.status"
        class="small text-muted mt-2 border-top pt-2"
      >
        Status: {{ lastTransaction.status }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TransactionError',
    props: {
      lastTransaction: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      errorMessage() {
        if (this.lastTransaction?.error_message) {
          return this.lastTransaction.error_message
        }
        // Fallback message
        return this.$t('home.return.error_message') || 'An error occurred during the transaction.'
      }
    }
  }
</script>

<style scoped>
  .transaction-error {
    max-width: 500px;
    margin: 0 auto;
  }
</style>
